import structure from '../../config/siteStructureConfig.js';
import constants from '../../config/constants.js';

const $inject = ['$rootScope', '$location', 'settingsService', 'authService', 'dataService', 'AUTH_EVENTS'];

const lbaNavCtrl = function ($rootScope, $location, settingsService, authService, dataService, AUTH_EVENTS) {
  let vm = this;

  vm.settings = settingsService.settings;
  vm.navActive = true;
  vm.logout = logout;
  vm.username = authService.getUsername();
  vm.changePath = changePath;
  vm.version = (window.version || '').toString();
  vm.displayVersion = (vm.version.split('.')[0] || '0') + '.' + (vm.version.split('.')[1] || '0');
  vm.structure = structure;

  if (window.showGlobalSettings) {

  } else {
    vm.structure.GlobalSettings = null;
  }

  vm.products = constants.PRODUCT_FAMILY;

  $rootScope.$on('lbaLoader:loaderState', (event, message) => {
    vm.showSpinner = message.state;
  });

  function logout() {
    $location.path(`/logout`);
  }

  function changePath(path) {
    // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
    dataService.backGridFilter = null;
    dataService.backGridPage = null;
    dataService.backViewGridFilter = null;
    dataService.backViewGridPage = null;

    dataService.refreshDataOnLoad = true;

    $location.path(`${path}`);
  }
};

lbaNavCtrl.$inject = $inject;

export default lbaNavCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaNav/lbaNavCtrl.js